import { Box, styled } from "@mui/material";

export const StyledWorkshops = styled(Box)(({ theme }) => ({
  height: "100%",
  ".header": {
    height: "15rem",
    background: theme.color.main,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    h1: {
      color: theme.color.background,
    },
  },
  ".info": {
    display: "flex",
    padding: "2rem 10rem",
    justifyContent: "center",
    gap: "7.5rem",
    alignItems: "center",
    ".imageWrapper": {
      width: "35rem",
      height: "25rem",
      border: `3px solid ${theme.color.dark}`,
      borderRadius: "10px",
      overflow: "hidden",
      img: {
        width: "100%",
        height: "100%",
        objectFit: "cover",
      },
    },
    ".content": {
      display: "flex",
      flexDirection: "column",
      width: "30rem",
      gap: "1rem",
      justifyContent: "center",
      "p, h2": {
        lineHeight: "1.8rem",
        fontFamily: "'Indie Flower', cursive",
        b: {
          color: theme.color.contrastColor,
        },
      },
      p: {
        fontSize: "1.3rem",
      },
      h2: {
        color: theme.color.contrastColor,
      },
    },
  },
  ".workshopWrapper": {
    padding: "2rem 10rem",
    display: "flex",
    flexDirection: "column",
    gap: "1rem",
    ".newWorkshop": {
      h2: {
        textAlign: "center",
        paddingBottom: "1rem",
        fontFamily: "'Avant que...', sans-serif",
      },
      svg: {
        position: "absolute",
        right: "2rem",
        top: "2rem",
        color: theme.color.contrastColor,
        cursor: "pointer",
        "&:hover": {
          color: theme.color.dark,
        },
      },
      ".workshopItem": {
        boxShadow: `0px 0px 3px 3px ${theme.contrast.lighter}`,
        padding: "2rem",
        borderRadius: "10px",
        display: "flex",
        gap: "2rem",
        position: "relative",
        justifyContent: "space-evenly",
        h3: {
          fontWeight: "bold",
          color: theme.color.contrastColor,
        },
        ".image": {
          width: "30rem",
          borderRadius: "10px",
          overflow: "hidden",
          img: {
            width: "100%",
            height: "100%",
            objectFit: "contain",
          },
        },
        ".content": {
          width: "40rem",
          button: {
            background: theme.color.contrastColor,
            "&:hover": {
              background: theme.color.dark,
            },
          },
        },
      },
    },
  },
  [`@media screen and (max-width: ${theme.breakpoints.values.tablet}px)`]: {
    ".header": {
      height: "25vh",
    },
    ".info": {
      flexDirection: "column",
      gap: "2rem",
      padding: "2rem 5rem",
      ".imageWrapper": {
        width: "30rem",
        height: "20rem",
      },
      ".content": {
        alignItems: "center",
        textAlign: "center",
      },
    },
    ".workshopWrapper": {
      padding: "2rem 5rem",
      ".newWorkshop": {
        ".workshopItem": {
          flexDirection: "column",
          alignItems: "center",
          ".image": {
            width: "20rem",
          },
          ".content": {
            width: "80%",
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            textAlign: "center",
          },
        },
      },
    },
  },
  [`@media screen and (max-width: ${theme.breakpoints.values.mobile}px)`]: {
    ".header": {
      height: "25vh",
    },
    ".info": {
      padding: "2rem 1rem",
      ".imageWrapper": {
        width: "20rem",
        height: "15rem",
      },
      ".content": {
        width: "100%",
      },
    },
    ".workshopWrapper": {
      padding: "2rem 1rem",
      ".newWorkshop": {
        ".workshopItem": {
          flexDirection: "column",
          alignItems: "center",
          ".content": {
            width: "100%",
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            textAlign: "center",
          },
        },
      },
    },
  },
}));
